import { AxiosResponse } from 'axios';

export const getFileNameFromContentDisposition = (contentDisposition: string) => {
  const match = contentDisposition.match(/filename=((.+);|(.*))/);
  return match ? match[2] || match[3] : '';
};

export const saveDownloadedFile = (response: AxiosResponse<File, any>, defaultFileName: string) => {
  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');
  const contentDisposition = response.headers['content-disposition'];

  link.download = contentDisposition ? getFileNameFromContentDisposition(contentDisposition) : defaultFileName;
  link.href = url;

  document.body.appendChild(link);

  link.click();

  link.parentNode?.removeChild(link);
};

export const convertBytesToMegabytes = (bytes: number): number => {
  return bytes / (1024 * 1024);
};
